// Import of the module
import { ColumnDef } from "@tanstack/react-table";
import { parseDateWithHoursUTC } from "@/lib/utils";

// Type of the fields in the table

export type AdminUserAction = {
  id: number;
  user_id: number;
  user_email?: string;
  date: string;
  action_button: string;
  page_from: string;
};

// Definition of the columns

export const admin_user_actions_columns: ColumnDef<AdminUserAction>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "user_email",
    header: "User",
    cell: ({ row }) => {
      return row.getValue("user_email") ?? "";
    },
  },
  {
    accessorKey: "date",
    header: "Date",
    cell: ({ row }) => {
      return parseDateWithHoursUTC(row.getValue("date"));
    },
  },
  {
    accessorKey: "action_button",
    header: "Action Name",
  },
  {
    accessorKey: "page_from",
    header: "Action Page",
  },
];
